/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Share_Back_ButtonInputs */



/**
* | output |
* | --- |
* | "Back" |
*
* @param {Team_Share_Back_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_share_back_button = /** @type {((inputs?: Team_Share_Back_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Share_Back_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Back")
	if (locale === "de") return /** @type {LocalizedString} */ ("Back")
	if (locale === "it") return /** @type {LocalizedString} */ ("Back")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Back")
	if (locale === "es") return /** @type {LocalizedString} */ ("Back")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Back")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Back")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Back")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Back")
	return /** @type {LocalizedString} */ ("Back")
});